import React, { useRef, useState } from "react";
import styles from './AutoCompleteInstructor.module.scss';
import TextField from "../textField/TextField";
import PropTypes from "prop-types";
import useClickOutside from "../../hooks/useClickOutside";
import ProfilePicture from "../profilePicture/ProfilePicture";
import {ReactComponent as XCircleIcon} from './XCircle.svg';

const AutoCompleteInstructor = ({
  label,
  placeholder,
  onChange,
  disabled,
  error,
  list = [],
  onAddNew
}) => {
  const [textValue, setTextValue] = useState('');
  const [showList, setShowList] = useState(false);
  const [selected, setSelected] = useState(null);
  const [filteredList, setFilteredList] = useState(list);
  const containerRef = useRef(null);

  useClickOutside(containerRef, () => setShowList(false));

  const handleChange = (value) => {
    if (value) {
      setFilteredList(list.filter(item =>
        (`${item.firstName} ${item.lastName}`).toLowerCase().includes(value.toLowerCase()) ||
        item.clinicalSite.toLowerCase().includes(value.toLowerCase()) ||
        item.specialities.toLowerCase().includes(value.toLowerCase()) ||
        item.email.toLowerCase().includes(value.toLowerCase())
      ));
    } else {
      setFilteredList(list);
    }
    setShowList(true);
    setTextValue(value);
  }

  const handleSelect = (item) => {
    setSelected(item);
    onChange(item);
    setShowList(false);
  };

  return (
    <div className={styles.container} ref={containerRef}>
      {selected ? <div className={styles.selected}>
        <ProfilePicture {...selected} />
        <div className={styles.details}>
          <span className={styles.name}>{selected.firstName} {selected.lastName}</span>
          <span className={styles.clinicalSite}>{selected.clinicalSite}</span>
        </div>
        <XCircleIcon onClick={() => {
          setSelected(null);
          onChange(null);
          setTextValue('');
        }}/>
      </div>: <TextField
        label={label}
        type="text"
        value={textValue}
        placeholder={placeholder}
        onChange={handleChange}
        onClick={() => handleChange(textValue)}
        disabled={disabled}
        error={error}
      />}
      {showList && <ul className={styles.list}>
        {filteredList.length > 0 && filteredList.map((item, index)=> {
          return (
            <li
              onClick={() => handleSelect(item)}
              key={`instructor-list-${index}`}
            >
              <ProfilePicture {...item} />
              <div className={styles.details}>
                <span className={styles.name}>{item.firstName} {item.lastName}</span>
                <span className={styles.clinicalSite}>{item.clinicalSite}</span>
              </div>
            </li>
          );
        })}
        {onAddNew && !selected && <li
          className={styles.addCta}
          onClick={() => onAddNew(textValue)}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 5V19M5 12H19" stroke="#1E1E1E" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Add Instructor
        </li>}
      </ul>}
    </div>
  );
};

AutoCompleteInstructor.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      instructorId: PropTypes.number.isRequired,
      firstName: PropTypes.string.isRequired,
      lastName: PropTypes.string.isRequired,
      profilePicture: PropTypes.string,
      clinicalSiteId: PropTypes.number.isRequired,
      clinicalSite: PropTypes.string.isRequired,
      specialities: PropTypes.string
    })
  ).isRequired,
  label: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  onAddNew: PropTypes.func
}

export default AutoCompleteInstructor;